export default function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    if (theirHandler) {
      theirHandler(event);
    }
    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
}